<app-card borderStyle="line">
  <div class="signings-monthly">
    <img class="signings-monthly__icon" src="../../../../../assets/images/lightbulb.svg" alt="" />
    @if((totalMonthlyClosings$ | async) !== undefined) {
    <p class="signings-monthly__text">
      This month <span class="emphasis">{{ totalMonthlyClosings$ | async }} others</span> have completed online notarizations.
    </p>
    } @else {
    <div class="signings-monthly__text--skeleton">
      <app-skeleton-text></app-skeleton-text>
      <app-skeleton-text></app-skeleton-text>
    </div>
    }
  </div>
</app-card>
